/** Original channel labels (API filter keys). Keys must stay stable for backend LoanTypeMap. */
export const originalChannelTypeOptions: Record<string, string> = {
  Wholesale: 'Wholesale',
  Correspondent: 'Correspondent',
  Retail: 'Retail',
  'Table Funder': 'Table Funder',
  Brokered: 'Brokered',
}

/** Display map: original label → display title. Mutated from Global Settings → Channel Options. */
export let channelTypeOptions: Record<string, string> = { ...originalChannelTypeOptions }

export const setChannelTypeOptions = (options: Record<string, string>) => {
  channelTypeOptions = options
}
